/******************************************************
 *                  MAIN APPLICATION MODULE
 *
 * This module will load others functional modules (analyze /
 * import / login / ...) as well
 * as global dependencies such as routing or ui.bootstrap
 ********************************************************/

"use strict";

import application from "./index";

// Authentication
import Auth from "@app/auth";

let Raven = require("raven-js");

console.log("Build: ", BUILD);
// testing cache build.

// Lorsqu'il est injecté, ce module surcharge le module de gestion des exceptions par défaut d'Angular.
// Les exceptions ne seront pas envoyées à Sentry dans l'environement de dev (car ENV.SENTRY_URL == null => la configuration sentry foir)
angular.module("myExceptions", []).factory("$exceptionHandler", [
	"$window",
	"$log",
	"ENV",
	function ($window, $log, ENV) {
		if ($window.Raven) {
			Raven.config(ENV.SENTRY_URL, {
				release: ENV.VERSION, environment: "Mobi-iti"
			}).install();
			return function (exception, cause) {
				$log.error.apply($log, arguments);
				Raven.captureException(exception);
			};
		} else {
			$log.error("Sentry conf not found (normal if you're developing), Using the default logging exception handler.");
			return function (exception, cause) {
				$log.error.apply($log, arguments);
			};
		}
	}
]);

application.constant("CONSTANTS", {

	// events
	EVENT_IMPORT_COMPLETE: "IMPORT_COMPLETED", // Import e-iti terminé.
	EVENT_EXPORT_COMPLETE: "EXPORT_COMPLETED", // Export Open-iti terminé
	EVENT_FB_ALERT_MESSAGE: "EVENT_FB_ALERT_MESSAGE", // Arrivée d'un message FB type alerte
	EVENT_FB_ALERT_MESSAGE_REMOVED: "EVENT_FB_ALERT_MESSAGE_REMOVED", // Suppression d'un message FB type alerte
	EVENT_FB_ALARM_MESSAGE: "EVENT_FB_ALARM_MESSAGE", // Arrivée d'un message FB type alarme
	EVENT_FB_ALARM_MESSAGE_REMOVED: "EVENT_FB_ALARM_MESSAGE_REMOVED",// Suppression d'un message FB type alarme
	EVENT_FB_LOCATION_MESSAGE: "EVENT_FB_LOCATION_MESSAGE", // Arrivée message géoloc générique FB
	EVENT_FB_START_COURSE_MONITORING: "EVENT_FB_START_COURSE_MONITORING", //Arrivée nouvelle course active FB
	EVENT_FB_STOP_COURSE_MONITORING: "EVENT_FB_STOP_COURSE_MONITORING", // Suppression d'une course active dans FB
	EVENT_MAP_NORMAL_MODE: "EVENT_MAP_NORMAL_MODE", // Basculer en mode normal sur la carto (i.e. toutes les courses, ou bien filtre).
	EVENT_FB_SERVICE_COURSE_ADDED_TO_MONITORING: "EVENT_FB_SERVICE_COURSE_ADDED_TO_MONITORING", // Un nouvel élément a été ajouté dans le tableau du FB service => une nouvelle course est monitorée sur la carto

	// attributes (DTO objects)
	ATT_OBJECT_KEY: "objectKey",
	ATT_PERMISSIONS: "permissions",
	ATT_API_TOKEN: "apiToken",
	ATT_COMPTAGE_CART: "cart",
	ATT_CLIENT_TYPE: "clientType",
	ATT_CURRENT_COMPANY: "company",
	ATT_COMPANIES_ID: "companiesId",
	ATT_COMPANY_OBJECT: "ATT_COMPANY_OBJECT",
	ATT_CLIENT_OBJECT: "ATT_CLIENT_OBJECT",
	ATT_CONFIGURATIONS: "ATT_CONFIGURATIONS",

	// map related constants
	MAP_FROM_PROJECTION: new OpenLayers.Projection("EPSG:4326"),  // Transform from WGS 1984
	MAP_TO_PROJECTION: new OpenLayers.Projection("EPSG:900913"), // to Spherical Mercator Projection
	MAP_LAYER_SIMPLE: "layer_simple",
	MAP_LAYER_STOP_POINTS_SELECTED: "layer_stopPointsSelected",
	MAP_LAYER_BEARING: "layer_bearing",
	MAP_LAYER_START_AND_STOP_POINT: "layer_start_and_stop",
	MAP_ROUTE_COLOR: "#0600CA",
	MAP_MARKER_DEFAULT: "assets/img/map_icons/pin-blue.png",
	MAP_MARKER_START: "assets/img/map_icons/pin-green.png",
	MAP_MARKER_END: "assets/img/map_icons/pin-red.png",
	MAP_MARKER_COMMERCIAL_POINT: "assets/img/map_icons/pin-green.png",

	// FORMAT
	FORMAT_STATS_SERVICE: "YYYY-MM-DD",

	// BOUNDARIES CONSTANTS
	SIZE_PICTURE_MAX: 1500000

});


angular.element(document).ready(function () {
	Auth.init()
		.then(() => {
			window.localStorage.setItem("roles", JSON.stringify(Auth.tokenParsed.realm_access.roles));
			window.localStorage.setItem("user", Auth.tokenParsed.preferred_username);
			let referential = window.sessionStorage.getItem("referential");
			let refs = sessionStorage.getItem("referentials") ? sessionStorage.getItem("referentials") : JSON.stringify(Auth.tokenParsed.orgs);
			window.localStorage.setItem("referentials", refs);

			let isSimulationTab = localStorage.getItem("openSimulation");

			if (isSimulationTab) {
				window.localStorage.removeItem("openSimulation");
				referential = window.localStorage.getItem("simulationRef");
				window.localStorage.removeItem("simulationRef");
			}

			let referentials = JSON.parse(localStorage.getItem("referentials"));
			if (referentials.length === 0) {
				window.alert("Accès refusé. Vous ne disposez pas de droits sur l'application. Veuillez contacter un administrateur.");
				Auth.logout();
			}
			if (!referential || (!referential.startsWith("simulation_") && !referentials.includes(referential))) {
				referential = referentials[0];
			}

			//Ouverture d'un espace de simulation
			window.sessionStorage.setItem("referential", referential);
			angular.bootstrap(document, ["application"]);
		})
		.catch((err) => {
			console.error(err)
			window.location.reload();
		});
});


application.factory("authInterceptor", [
	"$q",
	function ($q) {
		return {
			"request": function (config) {
				let deferred = $q.defer();
				config.headers = config.headers || {};
				if (Auth.loggedIn) {
					Auth.updateToken(5).then(() => {
						config.headers.Authorization = "Bearer " + Auth.token;
						config.headers["x-okina-referential"] = sessionStorage.getItem("referential");
						deferred.resolve(config);
					}).catch(function () {
						deferred.reject("Failed to refresh token");
					});
				}
				return deferred.promise;
			}, "requestError": function (rejection) {
				return $q.reject(rejection);
			},

			"response": function (response) {
				return response;
			},

			"responseError": function (response) {
				if (response.status == 401) {
					console.log("session timeout?");
					Auth.logout();
				} else if (response.status == 403) {
					console.error("Forbidden");
				} else if (response.status == 404) {
					console.error("Not found");
				} else if (response.status) {
					console.log(response.status);
					if (response.data && response.data.errorMessage) {
						console.error(response.data.errorMessage);
					} else {
						console.log("An unexpected server error has occurred");
					}
				} else if (response === "Failed to refresh token") {
					Auth.logout();
				}
				return $q.reject(response);
			}
		};
	}
]);

application.config([
	"$httpProvider", '$locationProvider',
	function ($httpProvider, $locationProvider) {
		$httpProvider.interceptors.push("authInterceptor");
		$locationProvider.hashPrefix('');
	}]);


/**
 * Common util functions and configuration.
 *
 */
application.run(["$rootScope", "$http", "$sessionStorage", function ($rootScope, $http, $sessionStorage) {
	$rootScope.isEmpty = function (obj) {
		for (var key in obj) {
			if (obj.hasOwnProperty(key)) {
				return false;
			}
		}
		return true;
	};
	$http.defaults.headers.common["x-okina-referential"] = $sessionStorage.referential;
}]);

application.directive("uiSelectFocusInput", ["$timeout", function ($timeout) {
	return {
		require: "ui-select", link: function (scope, $element, $attributes, selectController) {

			scope.$on("uis:activate", function () {
				// Give it time to appear before focus
				$timeout(function () {
					scope.$select.searchInput[0].focus();
				}, 1000);
			});
		}
	};
}]);


/**
 * Par défaut, passer le angular-datatable en français
 * Personnalisation du module
 */
application.run(["DTDefaultOptions", "DTOptionsBuilder", function (DTDefaultOptions, DTOptionsBuilder) {
	DTDefaultOptions.setLanguageSource("libs/datatable/French.json");
	DTOptionsBuilder.newOptions()
		.withPaginationType("full_numbers")
		.withDisplayLength(10);

}]);


application
	.config(["$logProvider", function ($logProvider) {
		$logProvider.debugEnabled(true);
	}]);


application.factory("StateSaved", ["$localStorage", function ($localStorage) {
	if ($localStorage.transactionsfilters === undefined) {
		$localStorage.transactionsfilters = {};
	}
	if ($localStorage.vehicleFillingfilters === undefined) {
		$localStorage.vehicleFillingfilters = {};
	}
	if ($localStorage.subscriberFiltersfilters === undefined || $localStorage.subscriberFiltersfilters == null) {
		$localStorage.subscriberFiltersfilters = {};
	}

	return {
		getTransactionsfilters: function () {
			return $localStorage.transactionsfilters;
		}, transactionsfiltersUpdate: function (transactionsfiltersUpdate) {
			$localStorage.transactionsfilters = transactionsfiltersUpdate;
		}, getVehicleFillingfilters: function () {
			return $localStorage.vehicleFillingfilters;
		}, vehicleFillingFiltersUpdate: function (vehicleFillingfiltersUpdate) {
			$localStorage.vehicleFillingfilters = vehicleFillingfiltersUpdate;
		}, getSubscriberFiltersfilters: function () {
			return $localStorage.subscriberFiltersfilters;
		}, getSubscriberAssignmentFilters: function () {
			return $localStorage.subscriberAssignmentFilters;
		}, subscriberFiltersfiltersUpdate: function (subscriberFiltersfiltersUpdate) {
			$localStorage.subscriberFiltersfilters = subscriberFiltersfiltersUpdate;
		}, subscriberAssignementFiltersUpdate: function (filter) {
			$localStorage.subscriberAssignmentFilters = filter;
		}, reset: function () {
			$localStorage.$reset({
				transactionsfilters: undefined,
				vehicleFillingfilters: undefined,
				subscriberFiltersfilters: undefined,
				subscriberAssignmentFilters: undefined
			});
		}
	};
}]);

// Override config options
application.config(["uibDatepickerPopupConfig", "uibDatepickerConfig", function (uibDatepickerPopupConfig, uibDatepickerConfig) {
	uibDatepickerPopupConfig.currentText = "Aujourd'hui";
	uibDatepickerPopupConfig.clearText = "Effacer";
	uibDatepickerPopupConfig.toggleWeeksText = "Afficher les semaines";
	uibDatepickerPopupConfig.closeText = "Fermer";
	uibDatepickerConfig.startingDay = 1;
	uibDatepickerConfig.datepickerPopup = "dd/MM/yyyy";
	uibDatepickerConfig.formatYear = "yyyy";
	uibDatepickerPopupConfig.datepickerPopup = "dd/MM/yyyy";
}]);


application.directive("fileread",
	function () {
		return {
			scope: {
				fileread: "="
			}, link: function (scope, element, attributes) {
				element.bind("change", function (changeEvent) {
					var reader = new FileReader();
					reader.onload = function (loadEvent) {
						scope.$apply(function () {
							scope.fileread = loadEvent.target.result;
						});
					};
					reader.readAsDataURL(changeEvent.target.files[0]);
				});
			}
		};
	}
);

application.directive("datepickerLocaldate",
	function () {
		var directive = {
			restrict: "A", require: ["ngModel"], link: link
		};
		return directive;

		function link(scope, element, attr, ctrls) {
			var ngModelController = ctrls[0];

			// called with a JavaScript Date object when picked from the datepicker
			ngModelController.$parsers.push(function (viewValue) {
				// undo the timezone adjustment we did during the formatting
				viewValue.setMinutes(viewValue.getMinutes() - viewValue.getTimezoneOffset());
				// we just want a local date in ISO format
				return viewValue.toISOString().substring(0, 10);
			});

			// called with a 'yyyy-mm-dd' string to format
			ngModelController.$formatters.push(function (modelValue) {
				if (!modelValue) {
					return undefined;
				}
				// date constructor will apply timezone deviations from UTC (i.e. if locale is behind UTC 'dt' will be one day behind)
				var dt = new Date(modelValue);
				// 'undo' the timezone offset again (so we end up on the original date again)
				dt.setMinutes(dt.getMinutes() + dt.getTimezoneOffset());
				return dt;
			});
		}
	}
);

/**
 * Pour se déplacer automatiquement au champs suivant dans un formulaire lorsque le maxlength est atteint.
 * Les id des inputs doivent être de la forme `formId-x`
 */
application.directive("moveNextOnMaxlength", function () {
	return {
		restrict: "A", link: function ($scope, element, attrs) {
			element.on("input", function (e) {
				if (element.val().length == element.attr("maxlength")) {
					const split = attrs.id.split("-");
					if (split.length === 2) {
						let nextId = split[0] + "-" + (parseInt(split[1]) + 1);
						let nextElement = document.getElementById(nextId);
						if (nextElement != null) {
							nextElement.focus();
						}
					}
				}
			});
		}
	};
});


application.config([
	"$httpProvider", function ($httpProvider) {

		if (!$httpProvider.defaults.headers.get) {
			$httpProvider.defaults.headers.get = {};
		}

		var isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
		var isSafari = /Safari/.test(navigator.userAgent) && /Apple Computer/.test(navigator.vendor);
		var isFirefox = navigator.userAgent.toLowerCase().indexOf("firefox") > -1;

		// Désactiver cache pour navigateurs à problèmes
		if (!isChrome && !isSafari && !isFirefox) {
			$httpProvider.defaults.headers.get["If-Modified-Since"] = "Mon, 26 Jul 1997 05:00:00 GMT";
			$httpProvider.defaults.headers.get["Cache-Control"] = "no-cache";
			$httpProvider.defaults.headers.get["Pragma"] = "no-cache";
		}
	}]);


/**
 * ROUTING
 *
 */
application
	.config([
		"$routeProvider",
		function ($routeProvider) {
			$routeProvider

				// Profil
				.when("/profil", {
					templateUrl: "app/profil/profil.tpl.html", controller: "ProfilCtrl", name: "profil", isPublic: true
				})


				// E-Iti

				.when("/e-iti/variations", {
					templateUrl: "app/e-iti/variations/variations.tpl.html",
					controller: "VariationsCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						lines: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getVariationsLines();
						}], newLines: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNewLines();
						}], deleteLines: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getDeleteLines();
						}], vehicleJourneys: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getVariationsVehicleJourneys();
						}], newVehicleJourneys: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNewVehicleJourneys();
						}], deleteVehicleJourneys: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getDeleteVehicleJourneys();
						}], stops: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getVariationsStops();
						}], newStops: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNewStops();
						}], deleteStops: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getDeleteStops();
						}]
					}
				})

				.when("/e-iti/recap", {
					templateUrl: "app/e-iti/summary/summary.tpl.html",
					controller: "SummaryCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						periods: ["ExploitTimetablesService", function (ExploitTimetablesService) {
							return ExploitTimetablesService.getProductionPeriods();
						}], linesCount: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getLinesCount();
						}], stopAreasCount: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getStopAreasCount();
						}], vehicleJourneysCount: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getVehicleJourneysCount();
						}], networks: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNetworkDetails();
						}], summaryLines: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getLinesSummary();
						}]
					}
				})

				.when("/e-iti/feed-info", {
					templateUrl: "app/e-iti/info/info.tpl.html",
					controller: "InfoCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						info: ["InfoService", function (InfoService) {
							return InfoService.getFeedInfo();
						}]
					}
				})

				// COMPANIES
				.when("/e-iti/companies/:id/edit", {
					templateUrl: "app/e-iti/companies/eiti-companies-edit.tpl.html",
					controller: "EitiCompaniesEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						company: ["EitiCompaniesService", "$route", function (EitiCompaniesService, $route) {
							return EitiCompaniesService.getCompany($route.current.params.id);
						}], mode: function () {
							return "edit";
						}
					}
				})
				.when("/e-iti/companies/new", {
					templateUrl: "app/e-iti/companies/eiti-companies-edit.tpl.html",
					controller: "EitiCompaniesEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						company: function () {
							return {};
						}, mode: function () {
							return "new";
						}
					}
				})
				.when("/e-iti/companies", {
					templateUrl: "app/e-iti/companies/eiti-companies.tpl.html",
					controller: "EitiCompaniesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						companies: ["EitiCompaniesService", function (EitiCompaniesService) {
							return EitiCompaniesService.getAll(true);
						}]
					}
				})


				.when("/e-iti/reseaux-lignes", {
					templateUrl: "app/e-iti/networks-lines/exploit-networks-lines.tpl.html",
					controller: "ExploitNetworkLinesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						networks: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNetworks();
						}], companies: ["EitiCompaniesService", function (EitiCompaniesService) {
							return EitiCompaniesService.getAll(true);
						}], categories: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getCategoriesForLines();
						}]
					}
				})
				.when("/e-iti/organisationReseaux", {
					templateUrl: "app/e-iti/networks-organization/networks-organization.tpl.html",
					controller: "NetworksOrganizationCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires", {
					templateUrl: "app/e-iti/routes/exploit-routes.tpl.html",
					controller: "ExploitRoutesCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/perturbations", {
					templateUrl: "app/e-iti/disruptions/eiti-disruptions.tpl.html",
					controller: "EitiDisruptionsCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						disruptions: ["EitiDisruptionsService", function (EitiDisruptionsService) {
							return EitiDisruptionsService.getCurrentMonthDisruptions();
						}]
					}
				})
				.when("/e-iti/perturbations/:id/edit", {
					templateUrl: "app/e-iti/disruptions/eiti-disruptions-edit.tpl.html",
					controller: "EitiDisruptionsEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						disruption: ["EitiDisruptionsService", "$route", function (EitiDisruptionsService, $route) {
							return EitiDisruptionsService.getDisruption($route.current.params.id);
						}], mode: function () {
							return "edit";
						}
					}
				})
				.when("/e-iti/perturbations/new", {
					templateUrl: "app/e-iti/disruptions/eiti-disruptions-edit.tpl.html",
					controller: "EitiDisruptionsEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						disruption: function () {
							return {};
						}, mode: function () {
							return "new";
						}
					}
				})

				.when("/e-iti/itineraires/:routeId", {
					templateUrl: "app/e-iti/routes/exploit-routes.tpl.html",
					controller: "ExploitRoutesCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires/:routeId/map-matching", {
					templateUrl: "app/e-iti/routes/map-matching-routes.tpl.html",
					controller: "MapMatchingRoutesCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires/:routeId/map-matching/:urlBack", {
					templateUrl: "app/e-iti/routes/map-matching-routes.tpl.html",
					controller: "MapMatchingRoutesCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires/:routeId/map-matching/:urlBack/:jpBack", {
					templateUrl: "app/e-iti/routes/map-matching-routes.tpl.html",
					controller: "MapMatchingRoutesCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires-points-arret", {
					templateUrl: "app/e-iti/routes/exploit-routes-points-arret.html",
					controller: "ExploitRoutesPointsArretCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires-points-arret/:routeId/:jpBack", {
					templateUrl: "app/e-iti/routes/exploit-routes-points-arret.html",
					controller: "ExploitRoutesPointsArretCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/itineraires-points-arret/:routeId", {
					templateUrl: "app/e-iti/routes/exploit-routes-points-arret.html",
					controller: "ExploitRoutesPointsArretCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/courses/route/:routeId", {
					templateUrl: "app/e-iti/courses/exploit-courses.tpl.html",
					controller: "ExploitCoursesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetables: ["ExploitTimetablesService", function (ExploitTimetablesService) {
							return ExploitTimetablesService.getAllTimetables();
						}]
					}
				})
				.when("/e-iti/courses/:routeId", {
					templateUrl: "app/e-iti/courses/exploit-courses.tpl.html",
					controller: "ExploitCoursesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetables: function () {
							return [];
						}
					}
				})
				.when("/e-iti/courses", {
					templateUrl: "app/e-iti/courses/exploit-courses.tpl.html",
					controller: "ExploitCoursesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetables: function () {
							return [];
						}
					}
				})
				.when("/e-iti/arrets", {
					templateUrl: "app/e-iti/stop-points/exploit-stop-points.tpl.html",
					controller: "ExploitStopPointsCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						networks: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNetworks();
						}]
					}
				})
				.when("/e-iti/arrets/:stopPointId", {
					templateUrl: "app/e-iti/stop-points/exploit-stop-points.tpl.html",
					controller: "ExploitStopPointsCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						networks: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getNetworks();
						}]
					}
				})

				// Calendriers
				.when("/e-iti/timetables/new", {
					templateUrl: "app/e-iti/timetables/timetables-edit.tpl.html",
					controller: "ExploitTimetablesNewCtrl",
					name: "e-iti",
					isPublic: false
				})
				.when("/e-iti/timetables/:id/edit", {
					templateUrl: "app/e-iti/timetables/timetables-edit.tpl.html",
					controller: "ExploitTimetablesEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetable: ["ExploitTimetablesService", "$route", function (ExploitTimetablesService, $route) {
							return ExploitTimetablesService.getTimeTable($route.current.params.id);
						}]
					}
				})
				.when("/e-iti/timetables/:id", {
					templateUrl: "app/e-iti/timetables/timetables-details.tpl.html",
					controller: "ExploitTimetablesEditCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetable: ["ExploitTimetablesService", "$route", function (ExploitTimetablesService, $route) {
							return ExploitTimetablesService.getTimeTable($route.current.params.id);
						}]
					}
				})
				.when("/e-iti/timetables", {
					templateUrl: "app/e-iti/timetables/timetables.tpl.html",
					controller: "ExploitTimetablesCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						timetables: ["ExploitTimetablesService", function (ExploitTimetablesService) {
							return ExploitTimetablesService.getAllTimetables(1, "endOfPeriod", "desc", null, null, null, true);
						}]
					}
				})


				//Courses spéciales
				.when("/e-iti/course-speciale", {
					templateUrl: "app/e-iti/courses-speciales/courses-speciales.tpl.html",
					controller: "CoursesSpecialesCtrl",
					name: "e-iti",
					isPublic: false
				})

				.when("/e-iti/course-speciale/new", {
					templateUrl: "app/e-iti/courses-speciales/courses-speciales-new.tpl.html",
					controller: "CoursesSpecialesCtrlNew",
					name: "e-iti",
					isPublic: false,
					resolve: {
						companies: ["EitiCompaniesService", function (EitiCompaniesService) {
							return EitiCompaniesService.getAll(true, true);
						}]
					}
				})

				.when("/e-iti/course-speciale/:id", {
					templateUrl: "app/e-iti/courses-speciales/courses-speciales-details.tpl.html",
					controller: "CoursesSpecialesCtrlDetails",
					name: "e-iti",
					isPublic: false,
					resolve: {
						course: ["CoursesSpecialesService", "$route", function (CoursesSpecialesService, $route) {
							return CoursesSpecialesService.getCourseSpeciale($route.current.params.id);
						}], editable: function () {
							return false;
						}
					}
				})

				.when("/e-iti/course-speciale/:id/edit", {
					templateUrl: "app/e-iti/courses-speciales/courses-speciales-details.tpl.html",
					controller: "CoursesSpecialesCtrlDetails",
					name: "e-iti",
					isPublic: false,
					resolve: {
						course: ["CoursesSpecialesService", "$route", function (CoursesSpecialesService, $route) {
							return CoursesSpecialesService.getCourseSpeciale($route.current.params.id);
						}], editable: function () {
							return true;
						}
					}
				})



				// OPEN-ITI
				.when("/data-management/imports/:referential/:id", {
					templateUrl: "app/e-iti/imports/open-imports-details.tpl.html",
					controller: "OpenImportsCtrlDetails",
					name: "data-management",
					isPublic: false,
					resolve: {
						importData: ["OpenImportsService", "$route", function (OpenImportsService, $route) {
							return OpenImportsService.getImport($route.current.params.referential, $route.current.params.id);
						}], actionReport: ["OpenImportsService", "$route", function (OpenImportsService, $route) {
							return OpenImportsService.getActionReport($route.current.params.referential, $route.current.params.id);
						}], okinaJobData: ["OpenImportsService", "$route", function (OpenImportsService, $route) {
							return OpenImportsService.getOkinaJobStatus($route.current.params.id);
						}], reportDetails: ["OpenImportsService", function (OpenImportsService) {
							return OpenImportsService.getReportDetails();
						}]
					}
				})
				.when("/data-management/imports/flex/:referential/:id", {
					templateUrl: "app/e-iti/imports/open-imports-flex-details.tpl.html",
					controller: "OpenImportsCtrlFlexDetails",
					name: "data-management",
					isPublic: false,
					resolve: {
						flexJob: ["OpenImportsService", "$route", function (OpenImportsService, $route) {
							return OpenImportsService.getGtfsFlexImportJob($route.current.params.id);
						}]
					}
				})
				.when("/data-management/imports/new", {
					templateUrl: "app/e-iti/imports/imports-component.tpl.html",
					controller: "ImportsComponentCtrl",
					name: "data-management",
					isPublic: false,
					resolve: {
						isAutomaticImport: function () {
							return false;
						},
						isNew: function () {
							return true;
						},
						importConfigurations: function () {
							return {};
						}, importConfiguration: function () {
							return {};
						}, targetNetworks: ["OpenImportsService", function (OpenImportsService) {
							return OpenImportsService.getAllActiveOperatorCompanies();
						}]
					}
				})
				.when("/data-management/imports/preview", {
					templateUrl: "app/e-iti/imports/open-imports-preview.tpl.html",
					controller: "OpenImportsCtrlPreview",
					name: "data-management",
					isPublic: false
				})
				.when("/data-management/imports", {
					templateUrl: "app/e-iti/imports/open-imports.tpl.html",
					controller: "OpenImportsCtrl",
					name: "data-management",
					isPublic: false
				})
				.when("/e-iti/itl-management", {
					templateUrl: "app/e-iti/itl-management/itl-management.tpl.html",
					controller: "itl-managementCtrl",
					name: "data-management",
					isPublic: false,
					resolve: {
						lines: ["ExploitationService", function (ExploitationService) {
							return ExploitationService.getAllLines();
						}]
					}
				})

				// Coherence
				.when("/e-iti/coherence", {
					templateUrl: "app/coherence/coherence-list.tpl.html",
					controller: "CoherenceListCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						type: ["CoherenceService", function (CoherenceService) {
							return CoherenceService.DOMAIN_TYPE.E_ITI;
						}], list: ["CoherenceService", function (CoherenceService) {
							return CoherenceService.getCoherenceList(CoherenceService.DOMAIN_TYPE.E_ITI);
						}]
					}
				})

				.when("/e-iti/coherence/detail/:id", {
					templateUrl: "app/coherence/coherence-detail.tpl.html",
					controller: "CoherenceDetailCtrl",
					name: "e-iti",
					isPublic: false,
					resolve: {
						type: ["CoherenceService", function (CoherenceService) {
							return CoherenceService.DOMAIN_TYPE.E_ITI;
						}], item: ["CoherenceService", "$route", function (CoherenceService, $route) {
							return CoherenceService.getCoherenceDetail($route.current.params.id);
						}]
					}
				})

				.when("/data-management/exports/:referential/:id", {
					templateUrl: "app/open-iti/exports/open-exports-details.tpl.html",
					controller: "OpenExportsCtrlDetails",
					name: "data-management",
					isPublic: false,
					resolve: {
						exportData: ["OpenExportsService", "$route", function (OpenExportsService, $route) {
							return OpenExportsService.getExport($route.current.params.referential, $route.current.params.id);
						}], actionReport: ["OpenExportsService", "$route", function (OpenExportsService, $route) {
							return OpenExportsService.getActionReport($route.current.params.referential, $route.current.params.id);
						}], okinaJobData: ["OpenExportsService", "$route", function (OpenExportsService, $route) {
							return OpenExportsService.getOkinaJobStatus($route.current.params.id);
						}]
					}
				})

				.when("/data-management/exports/new/type/:type", {
					templateUrl: "app/open-iti/exports/open-exports-new.tpl.html",
					controller: "OpenExportsCtrlNew",
					name: "data-management",
					isPublic: false,
					resolve: {
						type: ["$route", function ($route) {
							return $route.current.params.type;
						}]
					}
				})
				.when("/data-management/exports", {
					templateUrl: "app/open-iti/exports/open-exports.tpl.html",
					controller: "OpenExportsCtrl",
					name: "data-management",
					isPublic: false
				})
				.when("/data-management/exported-files", {
					templateUrl: "app/data-management/exported-files.tpl.html",
					controller: "ExportedFilesCtrl",
					name: "data-management",
					isPublic: false
				})

				.when("/data-management/operators", {
					templateUrl: "app/data-management/operators.tpl.html",
					controller: "OperatorsCtrl",
					name: "data-management",
					isPublic: false
				})
				.when("/data-management/operators/new", {
					templateUrl: "app/data-management/operators-edit.tpl.html",
					controller: "OperatorsEditCtrl",
					name: "data-management",
					isPublic: false,
					resolve: {
						operator: function () {
							return {};
						}, editMode: function () {
							return false;
						}
					}
				})
				.when("/data-management/operators/:id/edit", {
					templateUrl: "app/data-management/operators-edit.tpl.html",
					controller: "OperatorsEditCtrl",
					name: "data-management",
					isPublic: false,
					resolve: {
						operator: ["OperatorsService", "$route", function (OperatorsService, $route) {
							return OperatorsService.getOperator($route.current.params.id);
						}], editMode: function () {
							return true;
						}
					}


				})

				.when("/data-management/operators-admin", {
					templateUrl: "app/data-management/operators.tpl.html",
					controller: "OperatorsCtrl",
					name: "data-management",
					isPublic: false
				})


				.when("/open-iti/user", {
					templateUrl: "app/open-iti/open-form-user/open-form-user.tpl.html",
					controller: "OpenFormUserCtrl",
					name: "open-iti",
					isPublic: false,
					resolve: {
						subscribersUser: ["OpenFormUserService", function (OpenFormUserService) {
							return OpenFormUserService.getSubscribersUser();
						}]
					}
				})
				.when("/open-iti/user/:id/edit", {
					templateUrl: "app/open-iti/open-form-user/open-form-user-edit.tpl.html",
					controller: "OpenFormUserEditCtrl",
					name: "open-iti",
					isPublic: false,
					resolve: {
						subscriberUser: ["OpenFormUserService", "$route", function (OpenFormUserService, $route) {
							return OpenFormUserService.getSubscriberUser($route.current.params.id);
						}]
					}
				})

				// Mobi-iti
				.when("/data-management/validation", {
					templateUrl: "app/data-management/validation.tpl.html",
					controller: "ValidationCtrl",
					name: "mobi-iti",
					isPublic: false,
					resolve: {
						exportTemplates: ["AdminExportTemplatesService", function (AdminExportTemplatesService) {
							return AdminExportTemplatesService.getAllWithMosaicLines();
						}]
					}
				})




				// ADMIN CLIENTS
				.when("/admin/filiales/:id/edit", {
					templateUrl: "app/admin/clients/admin-client-edit.tpl.html",
					controller: "AdminClientsEditCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						client: ["AdminClientsService", "$route", function (AdminClientsService, $route) {
							return AdminClientsService.getClient($route.current.params.id);
						}], mode: function () {
							return "edit";
						}, schemas: ["AdminService", function (AdminService) {
							return AdminService.getAllSchemas();
						}]
					}
				})
				.when("/admin/filiales/new", {
					templateUrl: "app/admin/clients/admin-client-edit.tpl.html",
					controller: "AdminClientsEditCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						client: function () {
							return {};
						}, reports: function () {
							return [];
						}, mode: function () {
							return "add";
						}, schemas: ["AdminService", function (AdminService) {
							return AdminService.getAllSchemas();
						}]
					}
				})
				.when("/admin/filiales", {
					templateUrl: "app/admin/clients/admin-clients.tpl.html",
					controller: "AdminClientsCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}]
					}
				})
				.when("/admin/administration-tools", {
					templateUrl: "app/admin/tools/admin-tools.tpl.html",
					controller: "AdminToolsCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getCurrentUserClients();
						}]
					}

				})
				.when("/admin/db-exploration", {
					templateUrl: "app/admin/tools/db-exploration.tpl.html",
					controller: "DbExplorationCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}],
						configurationProperties: ["ConfigurationService", function (ConfigurationService) {
							return ConfigurationService.getAllConfigurationProperties();
						}]
					}

				})
				.when("/admin/consistency-tests", {
					templateUrl: "app/admin/tools/consistency-tests-screen.tpl.html",
					controller: "ConsistencyScreenCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}]
					}

				})
				.when("/admin/fares", {
					templateUrl: "app/admin/tools/fares.tpl.html",
					controller: "FaresCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}]
					}
				})
				.when("/admin/update", {
					templateUrl: "app/admin/update/update.tpl.html",
					controller: "UpdateCtrl",
					name: "admin",
					isPublic: false
				})
				.when("/admin/geoloc", {
					templateUrl: "app/admin/geoloc/admin-geoloc.tpl.html",
					controller: "AdminGeolocCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients();
						}]
					}
				})
				.when("/admin/overview", {
					templateUrl: "app/admin/tools/overview.tpl.html",
					controller: "OverviewCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getCurrentUserClients();
						}]
					}
				})
				.when("/admin/cleaning", {
					templateUrl: "app/admin/tools/cleaning.tpl.html",
					controller: "CleaningCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients();
						}]
					}
				})


				//TEMPLATE EXPORTS
				.when("/admin/export-templates/:id/global-export-monitoring", {
					templateUrl: "app/admin/export-templates/admin-export-monitoring.tpl.html",
					controller: "AdminExportMonitoringCtrl",
					name: "admin",
					isPublic: false,
					controllerAs: 'vm',
					resolve: {
						exportTemplateDetail: ["AdminExportTemplatesService", "$route", function (AdminExportTemplatesService, $route) {
							return AdminExportTemplatesService.get($route.current.params.id);
						}]
					}
				})
				.when("/admin/export-templates/:id/netex-export-monitoring", {
					templateUrl: "app/admin/export-templates/admin-netex-export-monitoring.tpl.html",
					controller: "AdminNetexExportMonitoringCtrl",
					name: "admin",
					isPublic: false,
					controllerAs: 'vm',
					resolve: {
						exportTemplateDetail: ["AdminExportTemplatesService", "$route", function (AdminExportTemplatesService, $route) {
							return AdminExportTemplatesService.get($route.current.params.id);
						}]
					}
				})
				.when("/admin/export-templates/:id/edit", {
					templateUrl: "app/admin/export-templates/admin-export-templates-edit.tpl.html",
					controller: "AdminExportTemplatesCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						exportTemplates: ["AdminExportTemplatesService", "$route", function (AdminExportTemplatesService, $route) {
							return AdminExportTemplatesService.get($route.current.params.id);
						}], consumers: ["AdminConsumersService", function (AdminConsumersService) {
							return AdminConsumersService.getAll();
						}]
					}
				})
				.when("/admin/export-templates/new", {
					templateUrl: "app/admin/export-templates/admin-export-templates-edit.tpl.html",
					controller: "AdminExportTemplatesCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						exportTemplates: function () {
							return [];
						}, consumers: ["AdminConsumersService", function (AdminConsumersService) {
							return AdminConsumersService.getAll();
						}]
					}
				})
				.when("/admin/export-templates", {
					templateUrl: "app/admin/export-templates/admin-export-templates.tpl.html",
					controller: "AdminExportTemplatesCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						exportTemplates: ["AdminExportTemplatesService", function (AdminExportTemplatesService) {
							return AdminExportTemplatesService.getAll();
						}], consumers: ["AdminConsumersService", function (AdminConsumersService) {
							return AdminConsumersService.getAll();
						}]
					}
				})


				//IMPORT CONFIGURATION
				.when("/admin/import-configuration", {
					templateUrl: "app/admin/import-configuration/admin-import-configuration.tpl.html",
					controller: "AdminImportConfigurationCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						importConfigurations: ["AdminImportConfigurationService", function (AdminImportConfigurationService) {
							return AdminImportConfigurationService.getAllImportConfiguration();
						}], client: function () {
							return {};
						}
					}
				})
				.when("/admin/import-configuration/new", {
					templateUrl: "app/e-iti/imports/imports-component.tpl.html",
					controller: "ImportsComponentCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						isAutomaticImport: function () {
							return true;
						},
						isNew: function () {
							return true;
						},
						importConfigurations: function () {
							return {};
						}, importConfiguration: function () {
							return {};
						}, targetNetworks: ["OpenImportsService", function (OpenImportsService) {
							return OpenImportsService.getAllActiveOperatorCompanies();
						}]
					}
				})
				.when("/admin/import-configuration/:id/edit", {
					templateUrl: "app/e-iti/imports/imports-component.tpl.html",
					controller: "ImportsComponentCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						isAutomaticImport: function () {
							return true;
						},
						isNew: function () {
							return false;
						},
						importConfigurations: function () {
							return {};
						},
						importConfiguration: ["AdminImportConfigurationService", "$route", function (AdminImportConfigurationService, $route) {
							return AdminImportConfigurationService.getImportConfiguration($route.current.params.id);
						}],
						targetNetworks: ["OpenImportsService", function (OpenImportsService) {
							return OpenImportsService.getAllActiveOperatorCompanies();
						}]
					}
				})

				//IMPORTS PARAMETERS
				.when("/admin/parameters/imports", {
					templateUrl: "app/admin/import-configuration/parameters/admin-imports-parameters.tpl.html",
					controller: "AdminImportsParametersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						importConfigurations: ["AdminImportConfigurationService", function (AdminImportConfigurationService) {
							return AdminImportConfigurationService.getAllImportConfiguration();
						}], client: function () {
							return {};
						}, importConfiguration: function () {
							return {};
						}, targetNetworks: function () {
							return {};
						}
					}
				})
				//EXPORTS PARAMETERS
				.when("/admin/parameters/exports", {
					templateUrl: "app/admin/export-templates/parameters/admin-exports-parameters.tpl.html",
					controller: "AdminExportsParametersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						exportTemplates: ["AdminExportTemplatesService", function (AdminExportTemplatesService) {
							return AdminExportTemplatesService.getAll();
						}], consumers: ["AdminConsumersService", function (AdminConsumersService) {
							return AdminConsumersService.getAll();
						}]
					}
				})

				//CONSOMMATEURS
				.when("/admin/consumers/:id/edit", {
					templateUrl: "app/admin/consumers/admin-consumers-edit.tpl.html",
					controller: "AdminConsumersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						consumers: ["AdminConsumersService", "$route", function (AdminConsumersService, $route) {
							return AdminConsumersService.get($route.current.params.id);
						}]
					}
				})
				.when("/admin/consumers/new", {
					templateUrl: "app/admin/consumers/admin-consumers-edit.tpl.html",
					controller: "AdminConsumersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						consumers: function () {
							return [];
						}
					}
				})
				.when("/admin/consumers", {
					templateUrl: "app/admin/consumers/admin-consumers.tpl.html",
					controller: "AdminConsumersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						consumers: ["AdminConsumersService", function (AdminConsumersService) {
							return AdminConsumersService.getAll();
						}]
					}
				})





				// ADMIN COMPANIES
				.when("/admin/companies/:id/edit", {
					templateUrl: "app/admin/companies/admin-companies-edit.tpl.html",
					controller: "AdminCompaniesEditCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						company: ["AdminCompaniesService", "$route", function (AdminCompaniesService, $route) {
							return AdminCompaniesService.getCompany($route.current.params.id);
						}], mode: function () {
							return "edit";
						}, clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients();
						}]
					}
				})
				.when("/admin/companies/new", {
					templateUrl: "app/admin/companies/admin-companies-edit.tpl.html",
					controller: "AdminCompaniesEditCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						company: function () {
							return {};
						}, mode: function () {
							return "new";
						}, clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients();
						}]
					}
				})
				.when("/admin/companies", {
					templateUrl: "app/admin/companies/admin-companies.tpl.html",
					controller: "AdminCompaniesCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						companies: ["AdminService", function (AdminService) {
							return AdminService.getAllCompanyAdmins();
						}]
					}
				})




				// ADMIN HISTORIQUE DES ACTIONS
				.when("/admin/action-logs", {
					templateUrl: "app/admin/action-logs/admin-action-logs.tpl.html",
					controller: "AdminActionLogsCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						actionTypes: ["AdminActionLogsService", function (AdminActionLogsService) {
							return AdminActionLogsService.getActionTypes();
						}], clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}]
					}
				})

				// ADMIN USERS
				.when("/admin/users", {
					templateUrl: "app/admin/users/admin-users.tpl.html",
					controller: "AdminUsersCtrl",
					name: "admin",
					isPublic: false,
					resolve: {
						users: ["AdminUsersService", function (AdminUsersService) {
							return AdminUsersService.getAllUsers();
						}], roles: ["AdminUsersService", function (AdminUsersService) {
							return AdminUsersService.getUserRoles();
						}], clients: ["AdminClientsService", function (AdminClientsService) {
							return AdminClientsService.getAllClients(true);
						}]
					}
				})


				.otherwise({
					resolve: {
						redirect: ["$q", "SecurityService", "$location", function($q, SecurityService, $location) {
							let deferred = $q.defer();
							if (SecurityService.hasRight("defaultRedirectToOverview")) {
								$location.path("/admin/overview");
							} else {
								$location.path("/e-iti/reseaux-lignes");
							}
							deferred.resolve();
							return deferred.promise;
						}]
					}
				});
		}
	])


	/**
	 Security.
	 Listens to route changes, and check if user is allowed on given route.
	 */
	.run(["$rootScope", "$location", "SecurityService", function ($rootScope, $location, SecurityService) {

		$rootScope.$on("$routeChangeStart", function (event, next) {
			// If next route is secured && current user is forbidden, redirect to login;
			if (next.name !== undefined && (!next.isPublic && !SecurityService.checkAccess(next.name))) {
				//Auth.logout(); fix role configuration to re enable
			}

		});

	}]);





